import { Species } from '@/Domain/Batch/Species'
import { SpeciesJson } from './SpeciesJson'

export class SpeciesDto {
  private _internalId: number
  private _binomen: string
  private _footNumber: string
  private _volume: string
  private _morphologyCode: number
  private _cost: string
  private _sawOneCost: string
  private _sawOneVolume: string
  private _sawTwoCost: string
  private _sawTwoVolume: string
  private _grindedCost: string
  private _grindedVolume: string
  private _observations: string

  static fromJSON (jsonData: SpeciesJson): SpeciesDto {
    return new this(
      jsonData.internalId,
      jsonData.binomen,
      jsonData.footNumber,
      jsonData.volume,
      jsonData.morphologyCode,
      jsonData.cost,
      jsonData.sawOneCost,
      jsonData.sawOneVolume,
      jsonData.sawTwoCost,
      jsonData.sawTwoVolume,
      jsonData.grindedCost,
      jsonData.grindedVolume,
      jsonData.observations
    )
  }

  static fromSpecies (species: Species): SpeciesDto {
    return new this(
      species.internalId(),
      species.binomen(),
      species.footNumber(),
      species.volume(),
      species.morphologyCode(),
      species.cost(),
      species.sawOneCost(),
      species.sawOneVolume(),
      species.sawTwoCost(),
      species.sawTwoVolume(),
      species.grindedCost(),
      species.grindedVolume(),
      species.observations()
    )
  }

  constructor (
    internalId: number,
    binomen: string,
    footNumber: string,
    volume: string,
    morphologyCode: number,
    cost: string,
    sawOneCost: string,
    sawOneVolume: string,
    sawTwoCost: string,
    sawTwoVolume: string,
    grindedCost: string,
    grindedVolume: string,
    observations: string
  ) {
    this._internalId = internalId
    this._binomen = binomen
    this._footNumber = footNumber
    this._volume = volume
    this._morphologyCode = morphologyCode
    this._cost = cost
    this._sawOneCost = sawOneCost
    this._sawOneVolume = sawOneVolume
    this._sawTwoCost = sawTwoCost
    this._sawTwoVolume = sawTwoVolume
    this._grindedCost = grindedCost
    this._grindedVolume = grindedVolume
    this._observations = observations
  }

  get binomen (): string {
    return this._binomen
  }

  get footNumber (): string {
    return this._footNumber ? this._footNumber : '-'
  }

  get volume (): string {
    return this._volume
  }

  get cost (): string {
    return this._cost ? this._cost : '-'
  }

  get observations (): string {
    return this._observations ? this._observations : '-'
  }

  get sawOneCost (): string {
    return this._sawOneCost ? this._sawOneCost : '-'
  }

  get sawOneVolume (): string {
    return this._sawOneVolume ? this._sawOneVolume : '-'
  }

  get sawTwoCost (): string {
    return this._sawTwoCost ? this._sawTwoCost : '-'
  }

  get sawTwoVolume (): string {
    return this._sawTwoVolume ? this._sawTwoVolume : '-'
  }

  get grindedCost (): string {
    return this._grindedCost ? this._grindedCost : '-'
  }

  get grindedVolume (): string {
    return this._grindedVolume ? this._grindedVolume : '-'
  }

  get internalId (): number {
    return this._internalId
  }

  get morphologyCode (): number {
    return this._morphologyCode
  }

  toJSON (): SpeciesJson {
    return {
      internalId: this.internalId,
      binomen: this.binomen,
      footNumber: this.footNumber,
      volume: this.volume,
      morphologyCode: this.morphologyCode,
      cost: this.cost,
      sawOneCost: this.sawOneCost,
      sawOneVolume: this.sawOneVolume,
      sawTwoCost: this.sawTwoCost,
      sawTwoVolume: this.sawTwoVolume,
      grindedCost: this.grindedCost,
      grindedVolume: this.grindedVolume,
      observations: this.observations
    }
  }
}
